<div>
  @for (filter of this.activeFilter(); track $index) {
    <span class="badge-container">
      <cam-badge [value]="filter.name" type="primary" icon="close" (clickAction)="this.remove(filter)"></cam-badge>
    </span>
  }
</div>
